module.exports = __webpack_public_path__ + "img/back.815d2134.png";